import { render, staticRenderFns } from "./companyJournal.vue?vue&type=template&id=8f0d17e8"
import script from "./companyJournal.vue?vue&type=script&lang=js"
export * from "./companyJournal.vue?vue&type=script&lang=js"
import style0 from "./companyJournal.vue?vue&type=style&index=0&id=8f0d17e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports